const admin_roles = ['CA']

export const is_user_admin = () => {
    const current_user = JSON.parse(localStorage.getItem('user'))
    if(
        localStorage.getItem('jwt') !== null
        && current_user
        && admin_roles.includes(current_user.roleCode)
    ){ 
        return true 
    } else {
        return false
    }
}
